export const eventData = {
  stocksCategoryListClick: 'stocks_category_list_click',
  stocksPopularListClick: 'stocks_popular_list_click',
}

export const eventMapping = {
  [eventData.stocksCategoryListClick]: {
    event: 'stocks_category_list_click',
    eventCategory: 'stocks_category_page_click',
  },
  [eventData.stocksPopularListClick]: {
    event: 'stocks_popular_list_click',
    eventCategory: 'stocks_category_page_click',
  },
}
